const stringOrStringArrayHasChanged = (newValue, oldValue) => {
  if (newValue === oldValue) {
    return false;
  }
  if (newValue === void 0 || oldValue === void 0) {
    return true;
  }
  if (Array.isArray(newValue) && Array.isArray(oldValue)) {
    if (newValue.length !== oldValue.length) {
      return true;
    }
    return newValue.some((value, index) => value !== oldValue[index]);
  }
  return newValue !== oldValue;
};
const dateOrStringHasChanged = (oldValue, newValue) => {
  if (oldValue === newValue) {
    return false;
  }
  if (!oldValue || !newValue) {
    return true;
  }
  if (typeof oldValue === "string" && typeof newValue === "string") {
    return oldValue !== newValue;
  }
  if (oldValue instanceof Date && newValue instanceof Date) {
    return oldValue.getTime() !== newValue.getTime();
  }
  return true;
};
const dateArrayHasChanged = (oldValue, newValue) => {
  if (oldValue === newValue) {
    return false;
  }
  if (!oldValue || !newValue) {
    return true;
  }
  if (oldValue.length !== newValue.length) {
    return true;
  }
  return oldValue.some((v, i) => dateOrStringHasChanged(v, newValue[i]));
};
export {
  dateArrayHasChanged,
  dateOrStringHasChanged,
  stringOrStringArrayHasChanged
};
